import { Space, Vector3 } from '@babylonjs/core/Maths/math';

import { normalizeDecimals } from '../../utils/nodeUtils';

export default class SlotLineChildNode {
  position: number;

  constructor(
    readonly id,
    readonly mesh,
    readonly requiredSpace: number,
    private readonly orientation: Vector3,
  ) {
    this.position = 0;
  }

  move = (position: number): void => {
    this.position = normalizeDecimals(position);
    this.mesh.setPositionWithLocalVector(Vector3.Zero());
    this.mesh.translate(this.orientation, position, Space.LOCAL);
    this.mesh.computeWorldMatrix(true);
  };

  get start(): number {
    return this.position;
  }

  get end(): number {
    return normalizeDecimals(this.position + this.requiredSpace);
  }
}
